<mat-icon [style]="notification | notificationIconStyle">{{notification | notificationIcon}}</mat-icon>
